<template>
	<div :id="name" class="cutscene-animation" :style="{'opacity':opacity}"></div>
</template>

<script>

	import bodyMoving from 'bodymovin';
	import howler from 'howler';
	import { url} from '../const/base';
	import {mapGetters , mapActions} from 'vuex';
	import Vue from 'vue';

	export default {

		props:[
			'name',
			'animationpath',
			'audiopath',
			'loop',
			'ratio',
			'autoplay',
			'opacity'
		],
		mounted(){
			this.initAudio();
			this.initAnimation();
		},

		beforeDestroy(){
			Vue.unloadAnimation(this.name);
			Vue.unloadAudio(this.name);
		},

		data(){
			return {
				baseUrl : url,
				animation : null,
				sound : null,
			}
		},

		methods:{

			play(){
				if(!this.hasAudio){
					if(this.animation != null) this.animation.goToAndPlay(0);
				}
				else if(this.animation != null && this.sound != null){
					this.sound.play();
					this.animation.goToAndPlay(0);
				}
			},

			initAudio(){
				if(!this.hasAudio) return;

				Vue.loadAudio(this.name , this.audiopath, ()=>
				{
					this.sound = this.getAudio();
					if(this.autoplay == "false") return;
					if(this.animation != null){
						this.sound.play();
						this.animation = this.playAnimation();
					}
				}, ()=>{
					console.log("Failed to load audio: " + this.audiopath);
				});
			},

			initAnimation(){

				Vue.loadAnimation(this.name , this.animationpath, document.getElementById(this.name), this.ratio, ()=>{
					this.animation = this.getAnimation();
					if(this.autoplay == "false") return;
					if(!this.hasAudio) this.playAnimation();
					else{
						if(this.sound != null){
							this.sound = this.playAudio();
							this.animation.play();
						}
					}
				});
			},

			playAnimation(){
				return Vue.playAnimation(this.name, {loop:this.loop == "true"});
			},

			getAnimation(){
				return Vue.getAnimation(this.name, {loop:this.loop == "true"});
			},

			playAudio(){
				return Vue.playAudio(this.name,  {loop:this.loop == "true"});
			},

			getAudio(){
				return Vue.getAudio(this.name, {loop:this.loop == "true"});
			},

			...mapActions([]),

		},
		computed:{

			hasAudio(){
				return this.audiopath != "" && this.audiopath != undefined;
			},

			...mapGetters([]),
		},

	}
</script>

<style scoped>

	.cutscene-animation svg{
		width: 100%;
		height: auto !important;
	}

</style>


// WEBPACK FOOTER //
// src/components/Lottie.vue